module.exports = __webpack_public_path__ + "img/image-02.98c4ce1c.webp";